export const ADD_FILTERED_MEDICAL_INSTITUTIONS =
  'addFilteredMedicalInstitutions'
export const ADD_FILTERED_DENTAL_CLINICS = 'addFilteredDentalClinics'
export const ADD_FILTERED_OPTICS = 'addFilteredOptics'
